import ProvisioningFormCustomCatalog from './ProvisioningFormCustomCatalog';

export default ProvisioningFormCustomCatalog;
